"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { Button } from "../../Button/index.js";
function Footer({ footerLeftNode, handleFooterCallBack }) {
    const onClickChange = ()=>{
        handleFooterCallBack(false);
    };
    const classes = footerLeftNode ? 'justify-between' : 'justify-end';
    return /*#__PURE__*/ jsxs("div", {
        className: `flex w-full items-center pt-4 ${classes}`,
        children: [
            footerLeftNode ? /*#__PURE__*/ jsx("div", {
                children: footerLeftNode
            }) : null,
            /*#__PURE__*/ jsx(Button, {
                size: "sm",
                type: "primary",
                onClick: onClickChange,
                children: "Done"
            })
        ]
    });
}
export { Footer };
